import { Injectable } from '@angular/core';
import { Constants } from '../../shared/constant';
import { BaseService } from '../../../core/base/base.service';


@Injectable()
export class SecurityCheckService extends BaseService {

      getServiceURL(): string {
            return '';
      }

      checksecurity(body: any): any {
            return this.getDataWithURL(Constants.UPDATE_PASSWORD_URL, body);
      }
}



// WEBPACK FOOTER //
// ./src/app/pages/login/security-check-forgotpass/security-check-fogotpass.service.ts